import React from 'react';
import ReactCrop from './react_crop/ReactCrop'
import { Button } from 'semantic-ui-react'
import './react_crop/ReactCrop.css'

const EMPTY_CROP = {
  x: 0,
  y: 0
}

class Crop extends React.Component {
  state = {
    crop: EMPTY_CROP
  }
  handleCropChanged = (crop) => {
    this.setState({ crop });
  }
  handleCropCompleted = (crop) => {
    this.props.onCrop(crop)
    this.setState({crop: EMPTY_CROP})
  }

  render = () => {
    if(this.props.adjustable) {
      return (
        <div>
          <ReactCrop
            ref='crop'
            style={{ width: 'auto', margin: 'auto' }}
            src={this.props.src}
            crop={this.state.crop}
            onChange={this.handleCropChanged.bind(this)}
            disabled={this.props.disabled}
            onFileError={this.props.onFileError}
          >
          {this.renderCropIcon()}
          </ReactCrop>
        </div>
      )
    }
    return (
      <ReactCrop
        ref='crop'
        style={{ width: 'auto', margin: 'auto' }}
        src={this.props.src}
        crop={this.state.crop}
        onChange={this.handleCropChanged.bind(this)}
        onComplete={this.handleCropCompleted.bind(this)}
        disabled={this.props.disabled}
        onFileError={this.props.onFileError}
      />
    )
  }

  renderCropIcon = () => {
    if(this.refs.crop) {
      const {
        offsetHeight,
        clientWidth,
        clientHeight
      } = this.refs.crop.imageRef

      return (
        <Button
          style={{
            position: 'fixed',
            left: `${(this.state.crop.x)*clientWidth/100}px`,
            bottom: `${offsetHeight - (this.state.crop.y)*clientHeight/100}px`,
            border: '2px solid grey',
            backgroundColor: 'white'
          }}
          icon='crop' circular
          disabled={this.props.editDisabled}
          onClick={(e) => this.handleCropCompleted(this.state.crop)}
        />
      )
    }
    return null
  }
}
export default Crop;



// WEBPACK FOOTER //
// ./src/component/Crop.js